(function(){
  // dezactivat – auto-gift oprit
  //aici setez daca se pune cartea automat in cos
  var ENABLE_AUTO_GIFT = false;
  if (!ENABLE_AUTO_GIFT) {
    return;
  }
  var CFG = (window.__AUTO_GIFT_CFG || {});
  var DEBUG = false; // setează false după ce finalizezi testele

  // Moneda activă (EUR / RON / etc.)
  var CURRENCY = (CFG.ACTIVE_CURRENCY || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'RON');
  var MAP = CFG.THRESHOLDS || { RON: 40000, EUR: 8000 };
  var THRESHOLD = MAP[CURRENCY] || MAP.RON || 40000; // fallback: 400 lei
  var GIFT_VARIANT_ID = CFG.GIFT_VARIANT_ID;
  var busy = false;

  function log(){ if (DEBUG && window.console) console.log('[AUTO-GIFT]', ...arguments); }

  if (!GIFT_VARIANT_ID){
    log('❗ Lipseste GIFT_VARIANT_ID. Oprire.');
    return;
  }

  // subtotal eligibil = total fără linia cadou (în "minor units" ai monedei ACTIVE)
  function eligibleSubtotal(cart){
    var sum = 0;
    if (!cart || !Array.isArray(cart.items)) return 0;
    cart.items.forEach(function(it){
      if (it.variant_id !== GIFT_VARIANT_ID){
        sum += (typeof it.final_line_price === 'number' ? it.final_line_price : 0);
      }
    });
    return sum;
  }

  function findGiftLine(cart){
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i=0; i<cart.items.length; i++){
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i]; // are .key
    }
    return null;
  }

  function addGift(){
    log('➕ Adaug cadoul…', GIFT_VARIANT_ID);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _auto_gift: '1' } }] })
    })
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, status:r.status, body:j}; }); })
    .then(function(res){
      if (!res.ok){
        log('❌ Eșec addGift', res.status, res.body);
      } else {
        log('✅ Add result', res.body);
        toast('🎁 Cartea-cadou a fost adăugată în coș');
      }
      return res;
    })
    .catch(function(e){
      log('❌ Eroare addGift', e);
    });
  }

  function removeGift(lineKey){
    log('➖ Scot cadoul…', lineKey);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, status:r.status, body:j}; }); })
    .then(function(res){
      if (!res.ok){
        log('❌ Eșec removeGift', res.status, res.body);
      } else {
        log('✅ Remove result', res.body);
      }
      return res;
    })
    .catch(function(e){
      log('❌ Eroare removeGift', e);
    });
  }

  function refreshDrawer(){
    try { document.dispatchEvent(new Event('cart:updated')); } catch(_){}
  }

  function toast(text){
    try{
       var el = document.createElement('div');
       el.textContent = text;
       el.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:20px;background:#10b981;color:#fff;padding:10px 12px;border-radius:8px;z-index:99999;font-weight:600;';
       document.body.appendChild(el);
       setTimeout(function(){ el.remove(); }, 2000);
    }catch(_){}
  }

  function sync(){
    if (busy){ log('…skip (busy)'); return; }
    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var sub = eligibleSubtotal(cart);
        var gift = findGiftLine(cart);
        log('Moneda=', CURRENCY, 'THRESHOLD=', THRESHOLD, 'subtotalEligibil=', sub, 'giftInCos=', !!gift);

        if (sub >= THRESHOLD){
          if (!gift) return addGift();
        } else {
          if (gift) return removeGift(gift.key);
        }
      })
      .catch(function(e){ log('❌ Eroare cart.js', e); })
      .finally(function(){ busy = false; refreshDrawer(); });
  }

  // Hook-uri
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('cart:updated', function(){ setTimeout(sync, 150); });

  // când se face add-to-cart din formulare sau quick add
  document.addEventListener('submit', function(e){
    try{
      var f = e.target;
      if (f && (f.matches?.('product-form form') || (f.action && /\/cart\/add/.test(f.action)))){
        setTimeout(sync, 600);
        setTimeout(sync, 1500);
      }
    }catch(_){}
  }, true);

  // patch fetch/XHR pentru update-uri făcute de alte scripturi
  (function patchNetwork(){
    if (!window.__giftFetchPatched){
      var _f = window.fetch;
      window.fetch = function(input, init){
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var p = _f(input, init);
        try{
          if (/\/cart(\.js|\/add\.js|\/change\.js|\/update\.js)(\?|$)/.test(url)){
            p.then(function(){ setTimeout(sync, 0); setTimeout(sync, 600); setTimeout(sync, 1500); });
          }
        }catch(_){}
        return p;
      };
      window.__giftFetchPatched = true;
    }
    if (!window.__giftXHRPatched && typeof XMLHttpRequest !== 'undefined'){
      var _open = XMLHttpRequest.prototype.open;
      var _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url){
        this.__giftIsCartReq = typeof url === 'string' && /\/cart(\.js|\/add\.js|\/change\.js|\/update\.js)(\?|$)/.test(url);
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function(){
        if (this.__giftIsCartReq){
          this.addEventListener('load', function(){
            setTimeout(sync, 0);
            setTimeout(sync, 600);
            setTimeout(sync, 1500);
          });
        }
        return _send.apply(this, arguments);
      };
      window.__giftXHRPatched = true;
    }
  })();
})();
